export enum ActiveInactiveStatus {
    Active,
    Inactive,
}

export const ActiveInactiveStatusAsBoolean = (s: ActiveInactiveStatus) => (
    s === ActiveInactiveStatus.Active
);

export const BooleanAsActiveInactiveStatus = (b: boolean) => (
    b ? ActiveInactiveStatus.Active : ActiveInactiveStatus.Inactive
);
